import Button, { type ButtonType } from "@common/controls/Button/component";
import { FormButtons } from "@common/controls/Form/component";
import Modal from "@common/controls/Modal/component";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";

export interface OKModalProps {
  className?: string;
  isCentered?: boolean;
  isVisible: boolean;
  title?: any;
  children?: any;
  onClose: () => any;

  button?: {
    caption?: string;
    type?: ButtonType;
  };
  width?: number | string;
}

const OKModal = ({ isCentered = true, ...props }: OKModalProps) => {
  const i18n = useI18n();

  return (
    <Modal {...props} isCentered={isCentered} hasBackdrop>
      <Modal.Header title={props.title} onCloseClick={props.onClose} />
      <Modal.Body>{props.children}</Modal.Body>
      <Modal.Footer>
        <FormButtons>
          <Button onClick={props.onClose} type={props.button?.type}>
            {props.button?.caption ?? i18n.ok}
          </Button>
        </FormButtons>
      </Modal.Footer>
    </Modal>
  );
};

export default OKModal;
